import {SORespInterphace} from '../../core/interphace/so-resp-interphace';
import {InterphaceCore} from './interphace.core';
import {CEBase} from 'lionheartland';
import {EntityViewSpecProtocol} from 'lionheartland';
import { CommanderApp } from "../../land-app";
import {PutInterphaceFormFields} from './put-interphace-form-fields';
import { CEInterphaceAttributes } from './ce-interphace-attributes'


export class CEInterphaceBase extends CEBase {

    public details: CEInterphaceAttributes;
    public fromFields: PutInterphaceFormFields = new PutInterphaceFormFields();

    constructor(
        public parentEntityViewSpec: EntityViewSpecProtocol,
        public core: InterphaceCore,
        public entity: SORespInterphace,
        public app: CommanderApp,
    ) {
        super(
            parentEntityViewSpec, core, entity, app,
        )
        this.details = new CEInterphaceAttributes(
            parentEntityViewSpec,
            entity,
            app,
            this.fromFields
        );
        this.setAttributes();
        this.sortAttributes();
    }

    setAttributes() {

        this.attributes = []
        this.attributes.push(this.details.name)
        this.attributes.push(this.details.description)
        this.attributes.push(this.details.interphaceType)
        this.attributes.push(this.details.blocks)
        this.attributes.push(this.details.entity)
        this.attributes.push(this.details.attributeSpecs)
        this.attributes.push(this.details.project)

    }
}